// extracted by mini-css-extract-plugin
export default {"terms":"styles-module__terms___lXYeX","articles":"styles-module__articles___Q3p43"};